'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

// Underconstruction warning and premited IP's
var isPermited = ['217.145.92.194', '46.10.239.4'];
var isUnderConstruction = false;

// Api url
var apiUrl = undefined;

if (__PRODUCTION__) {
	apiUrl = 'https://api.group-ood.com';
} else if (__STAGING__) {
	apiUrl = 'https://staging-api.group-ood.com';
} else if (__DEV__) {
	apiUrl = 'http://staging-group-api.asterart.com';
} else {
	apiUrl = 'http://staging-group-api.asterart.com';
}

angular.module('BTMS', ['Components', 'ngCookies', 'ui.router', 'ngAnimate', 'ngResource', 'ngSanitize', 'angularMoment', 'duScroll', 'pascalprecht.translate', 'bw.paging', '720kb.datepicker', 'toastr', 'angular-loading-bar']).config(function ($urlRouterProvider, cfpLoadingBarProvider, $locationProvider, $httpProvider, $stateProvider, toastrConfig) {
	'ngInject';

	$httpProvider.interceptors.push('authInterceptor');

	$locationProvider.html5Mode(true);
	var defaultPage = '/';

	// Use $urlRouterProvider to configure any redirects (when) and invalid urls (otherwise).
	$urlRouterProvider
	// If the url is ever invalid, e.g. '/asdf', then redirect to '/' aka the homepage state
	.otherwise(defaultPage);

	// Use $stateProvider to configure your states.
	$stateProvider.state('app', {
		// With abstract set to true, that means this state can not be explicitly activated.
		// It can only be implicitly activated by activating one of its children.
		abstract: true,
		template: '<section ui-view class="app-wrapper"></section>'
	}).state('app.public', {
		// With abstract set to true, that means this state can not be explicitly activated.
		// It can only be implicitly activated by activating one of its children.
		abstract: true,
		template: '<section ui-view class="app-public-wrapper"></section>'
	});

	// Toastr container config
	angular.extend(toastrConfig, {
		autoDismiss: true,
		maxOpened: 5,
		newestOnTop: false,
		positionClass: 'toast-bottom-left'
	});

	// Toastr config
	angular.extend(toastrConfig, {
		allowHtml: true,
		extendedTimeOut: 2000,
		closeButton: true,
		closeHtml: '<button><i class="fa fa-times"></i></button>',
		iconClasses: {
			error: 'btms-error',
			info: 'btms-info',
			success: 'btms-success',
			warning: 'btms-warning'
		},
		tapToDismiss: false,
		timeOut: 5000
	});
}).run(runConfig).run(detectMouseMove).run(refreshToken).run(function ($templateCache) {
	'ngInject';

	$templateCache.put('partials/add-edit-bus.html', require('./partials/add-edit-bus.html'));
	$templateCache.put('partials/add-edit-line-station.html', require('./partials/add-edit-line-station.html'));
	$templateCache.put('partials/add-edit-price.html', require('./partials/add-edit-price.html'));
	$templateCache.put('partials/list-price-sub-lines.html', require('./partials/list-price-sub-lines.html'));
	$templateCache.put('partials/change-password.html', require('./partials/change-password.html'));
	$templateCache.put('partials/choose-line.html', require('./partials/choose-line.html'));
}).constant('AppConstants', {
	'serverUrl': 'http://localhost:3000',
	// 'apiUrl': 'http://api.dary.bg',
	// 'apiUrl': 'http://api-dev.dary.bg',
	// 'apiUrl': 'http://api-staging.dary.bg'
	// 'apiUrl': 'http://group-api.158.bg',
	'apiUrl': apiUrl,
	'languages': ['bg', 'en'],
	'perPage': 15,
	'colors': {
		'darkBlue': '#1E1F26',
		'activeIndigo': '#4D648D'
	}
});

/** Refresh token every 45 minutes*/
function refreshToken($timeout, $http, AppConstants, $cookieStore) {
	'ngInject';

	var refreshTokenInterval = 30 * 60000;

	setInterval(function () {

		if (typeof $cookieStore.get('token') !== 'undefined') {
			$http.post(AppConstants.apiUrl + '/auth-refresh?token=' + $cookieStore.get('token')).then(function (data) {
				$cookieStore.put('token', data.data.data.token);
			})['catch'](function (err) {
				console.log(err);
			});
		}
	}, refreshTokenInterval);
}

/** Listen for mouse movement and logout user after period of time of inactivity */
function detectMouseMove($document, $timeout, $state, Auth) {
	'ngInject';

	var debounceValue = 1 * 1000;
	var timeOutValue = 30 * 60000;
	var timeoutThread = $timeout(function () {
		logOutByTimer();
	}, timeOutValue);

	angular.element($document).bind('mousemove', _lodash2['default'].debounce(function () {
		timeoutResseter();
	}, debounceValue));

	/** Reset timeout timer on mouse move*/
	function timeoutResseter() {
		$timeout.cancel(timeoutThread);
		timeoutThread = $timeout(function () {
			logOutByTimer();
		}, timeOutValue);
	}

	/** Call logout function from Auth service*/
	function logOutByTimer() {
		Auth.logout();
	}
}

function runConfig(Auth, SidebarService, $rootScope, $state) {
	'ngInject';

	// Show loading screen and hide it after page content is loaded
	var splash = angular.element(document.getElementById('renderScreen'));
	var body = angular.element(document.getElementsByTagName('body')[0]);

	// lock body and prevent scrolling
	body.css({ 'height': '100vh', 'overflow': 'hidden' });
	angular.element(document).ready(function () {
		splash.addClass('fade-out');
		body.css({ 'height': 'auto', 'overflow': 'auto' });
	});

	// Used to show and hide elements on page
	$rootScope.$state = $state;

	if (isUnderConstruction) {
		if (isPermited.indexOf(userip) === -1) {
			$state.go('app.public.under-construction');
		}
	}

	$rootScope.$on('$stateChangeStart', function (event, next) {
		// Create object with unavailable routes for agent and office
		var availableRoutes = {
			'agent': ['app.private.tickets.chooseSubLine', 'app.private.tickets.create', 'app.private.tickets.edit', 'app.private.reports.list', 'app.private.reports.show', 'app.private.sales.list', 'app.private.sales.show', 'app.private.discounts.list', 'app.public.btms.home', 'app.public.btms.about-us', 'app.public.btms.buy-ticket', 'app.public.btms.choose-seat', 'app.public.btms.contacts', 'app.public.btms.terms', 'app.public.btms.privacy', 'app.public.btms.cookie-policy', 'app.public.btms.payment', 'app.public.btms.payment-ready', 'app.public.btms.terms-and-conditions', 'app.private.changePassword'],
			'office': ['app.private.tickets.chooseSubLine', 'app.private.tickets.create', 'app.private.tickets.edit', 'app.private.reports.list', 'app.private.reports.show', 'app.private.sales.list', 'app.private.sales.show', 'app.private.discounts.list', 'app.public.btms.home', 'app.public.btms.about-us', 'app.public.btms.buy-ticket', 'app.public.btms.choose-seat', 'app.public.btms.contacts', 'app.public.btms.terms', 'app.public.btms.privacy', 'app.public.btms.cookie-policy', 'app.public.btms.payment', 'app.public.btms.payment-ready', 'app.public.btms.terms-and-conditions', 'app.private.waybill', 'app.private.waybill.show', 'app.private.waybill.chooseBus', 'app.private.changePassword']
		};

		// Create object with unavailable routes for owner and administrator
		var unavailableRoutes = {
			'administrator': ['app.private.cities.list', 'app.private.cities.create', 'app.private.cities.edit', 'app.private.stations.list', 'app.private.stations.create', 'app.private.stations.edit', 'app.private.buses', 'app.private.buses.list', 'app.private.buses.chooseLine', 'app.private.seats', 'app.private.seats.edit', 'app.private.seats.chooseLine', 'app.private.discounts', 'app.private.discounts.list', 'app.private.discounts.edit', 'app.private.discounts.create', 'app.private.lines.list', 'app.private.lines.create', 'app.private.lines.edit', 'app.private.prices.chooseLine', 'app.private.prices.list', 'app.private.promotions.create', 'app.private.promotions.edit', 'app.private.promotions.list', 'app.private.promotions.editLines.add', 'app.private.promotions.editLines.list', 'app.private.administrators.create', 'app.private.administrators.edit', 'app.private.administrators.list'],
			'owner': ['app.private.cities.list', 'app.private.cities.create', 'app.private.cities.edit', 'app.private.stations.list', 'app.private.stations.create', 'app.private.stations.edit']
		};
		Auth.isLoggedInAsync(function (isLoggedIn) {
			if (next.name === 'app.public.login' && isLoggedIn) {
				event.preventDefault();
				$state.go('app.private.tickets.chooseSubLine');
			}
			// Check if private is accessed and is user logged
			if (next.name && next.name.match(/^app\.private\./) && !isLoggedIn) {
				event.preventDefault();
				$state.go('app.public.login');
			} else {
				if (Auth.getCurrentUser().roles && Auth.getCurrentUser().roles.length) {
					SidebarService.setCurrentUserRoles(Auth.getCurrentUser().roles);

					// Pluck all role names into array of strings
					var roleNames = _lodash2['default'].pluck(Auth.getCurrentUser().roles, 'name');
					// User is owner
					var isOwner = roleNames.indexOf('owner') !== -1;
					// User is administrator
					var isAdministrator = !isOwner && roleNames.indexOf('administrator') !== -1;
					// User is office
					var isOffice = !isOwner && !isAdministrator && roleNames.indexOf('office') !== -1;
					// User is agent
					var isAgent = !isOwner && !isAdministrator && !isOffice && roleNames.indexOf('agent') !== -1;

					// Check owner permissions to access a route
					if (isOwner && unavailableRoutes.owner.indexOf(next.name) !== -1) {
						event.preventDefault();
						$state.go('app.private.tickets.chooseSubLine');
						return false;
					}

					// Check administrator permissions to access a route
					if (isAdministrator && unavailableRoutes.administrator.indexOf(next.name) !== -1) {
						event.preventDefault();
						$state.go('app.private.tickets.chooseSubLine');
						return false;
					}

					// Check office and agent permissions to access a route
					if (isAgent && availableRoutes.agent.indexOf(next.name) === -1) {
						event.preventDefault();
						$state.go('app.private.tickets.chooseSubLine');
						return false;
					}

					// Check office and agent permissions to access a route
					if (isOffice && availableRoutes.office.indexOf(next.name) === -1) {
						event.preventDefault();
						$state.go('app.private.tickets.chooseSubLine');
						return false;
					}
				}
			}
		});
	});
}


/** WEBPACK FOOTER **
 ** ./client/app.js
 **/